enum EntitySortOrder {
  None,
  LandAreaHighToLow,
  LandAreaLowToHigh,
}

export default EntitySortOrder
